"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPreviewComponent = void 0;
const react_1 = __importStar(require("react"));
const react_hook_form_1 = require("react-hook-form");
const function_client_1 = require("@/utils/function-client");
const userSchema_1 = require("./userSchema");
const schemaComponents_1 = require("@/schemaComponents");
const components_1 = require("utils/components");
const getPreviewComponent = ({ projectId }) => {
    const PreviewComponent = ({ control }) => {
        const { email } = (0, react_hook_form_1.useWatch)({ control });
        const [userRecord, userRecordLoading] = (0, function_client_1.useGetAdminUserRecord)(email ? { email } : undefined);
        const userSchema = (0, react_1.useMemo)(() => (0, userSchema_1.getUserSchema)({ projectId }), [projectId]);
        return email && userRecordLoading ? (react_1.default.createElement(components_1.Loading, null)) : (react_1.default.createElement(schemaComponents_1.DynamicField, { data: userRecord, schema: userSchema }));
    };
    return PreviewComponent;
};
exports.getPreviewComponent = getPreviewComponent;
